import List from './List';
import { gql } from '@apollo/client';
import Show from './Show';
import Create from './Create';
import Edit from './Edit';

export default {
  name: 'market_location_type_rate_settings',
  inputShow: gql`
    query marketLocationTypeRateSettings($input: MarketLocationTypeRateSettingQueryInput) {
      marketLocationTypeRateSettings(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Rates',
    label: 'Market Location Type Rate Settings',
    order: 7,
  },
};
